"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fnGetKeyByValue = fnGetKeyByValue;
/**
 * @name fnGetKeyByValue
 * @description 객체에서 값으로 키를 찾아 반환합니다.
 * @param {T} object
 * @param {K} value
 * @returns {K}
 */
function fnGetKeyByValue(object, value) {
    const key = Object.keys(object).find((key) => object[key] === value);
    if (key !== value && typeof key !== 'undefined') {
        return key;
    }
    return value;
}
